import React, { Component } from "react";
import { Form, FormGroup, Button, Col, FormControl } from "react-bootstrap";
import { Social } from "./index";

const styles = {
  mainImage: {
    borderRadius: "50%",
    height: "255",
    margin: "1rem auto",
    border: "5px solid white"
  },
  container: {
    display: "flex",
    margin: "0 auto",
    maxWidth: "1200",
    padding: "0 .5rem",
    flexFlow: "column wrap"
  },
  center: {
    flex: "column wrap",
    margin: "1rem",
    textAlign: "center"
  }
};

// const formInstance = (
//   <div style={{ marginTop: "25" }} className="col-md-12 col-md-offset-4">
//     <Form horizontal style={{ display: "block", margin: "0 auto" }}>
//       <FormGroup controlId="formHorizontalName">
//         <Col sm={10}>
//           <FormControl type="text" placeholder="Name" />
//         </Col>
//       </FormGroup>
//       <FormGroup controlId="formHorizontalEmail">
//         <Col sm={10}>
//           <FormControl type="email" placeholder="Email" />
//         </Col>
//       </FormGroup>
//       <FormGroup controlId="formHorizontalMessage">
//         <Col sm={10}>
//           <FormControl type="text" placeholder="Message" />
//         </Col>
//       </FormGroup>
//       <FormGroup>
//         <Col style={{ width: "35%" }} smOffset={1} sm={12}>
//           <Button style={{ width: "50%" }} type="submit">
//             Send
//           </Button>
//         </Col>
//       </FormGroup>
//     </Form>
//   </div>
// );

export default class Contact extends Component {
  render() {
    return (
      <div style={styles.container} className="container">
        <div style={styles.center}>
          <div style={{ margin: "1rem" }}>
            <h2 style={{ margin: "1rem" }}> Contact Me </h2>
            <img
              style={styles.mainImage}
              src={require("./assets/linkedinpic.jpg")}
              alt="contact-me"
            />
          </div>
        </div>
        <div style={styles.center}>
          <Social />
        </div>
      </div>
    );
  }
}
